import React from "react";
import BlackHeader from "../Layout/BlackHeader/BlackHeader";
import MetaDecorator from "../Util/MetaDecorator";
import Footer from "../Layout/Footer/Footer";
import styles from "./Sfdr.module.scss";
import styles2 from "./ModernSlaveryStatement.module.scss";

const ModernSlaveryStatement = () => {
	return (
		<>
			<div className="sticky-header">
				<BlackHeader />
			</div>
			<MetaDecorator
				title={"Modern Slavery Statement | LRC Group"}
				description={"Anti-Slavery and Human Trafficking Statement"}
			/>
			<div id="main-container">
				<section className={styles.DisclaimerAlignment}>
					<div className={styles.boxCenterAlignment}>
						<div className={styles.boxWidth}>
							<div className={styles.pageTitle}>
								<h1>Anti-Slavery and Human Trafficking Statement</h1>
							</div>
							<div className={styles2.statement}>
								<p>This statement is made pursuant to:</p>
								<ul className={styles2.dash}>
									{StatemenList.map((item) => (
										<li>{item}</li>
									))}
								</ul>
								<p>
									and any other such legislative acts applying at the current
									time or in the future. We utilise{" "}
									<a
										href="https://antislaverylaw.ac.uk/"
										style={{ cursor: "pointer" }}>
										https://antislaverylaw.ac.uk/
									</a>{" "}
									as a resource to keep track of such legislation.
								</p>
								<p style={{ margin: "12px 0" }}>
									This statement constitutes our anti-slavery and human
									trafficking statement for the financial year ending December
									2024. This statement will be reviewed annually and updated
									where necessary to reflect changes in circumstances and actual
									practice.{" "}
								</p>
								<p>
									<b>“Modern slavery”</b> refers to the offences of human
									trafficking, slavery, servitude, and forced or compulsory
									labour;
								</p>
								<ul style={{ paddingLeft: "28px" }}>
									{StatemenList2.map((item) => (
										<li>{item}</li>
									))}
								</ul>
								<p style={{ margin: "12px 0" }}>
									Modern slavery includes victims who have been brought from
									overseas and vulnerable people who are forced to work
									illegally against their will across different sectors such as
									construction, manufacturing, agriculture, hospitality and
									retail.
								</p>
								<p style={{ margin: "12px 0" }}>
									<b>“Human trafficking”</b> involves the recruitment, transfer
									or obtaining of an individual through coercion, abduction,
									fraud or force to exploit them. Although human trafficking
									often involves an international cross-border element, it is
									also possible to be a victim of modern slavery within your own
									country. There are several broad categories of exploitation
									linked to human trafficking, including sexual exploitation,
									forced labour, domestic servitude, organ harvesting, child
									related crimes, forced marriage and illegal adoption.
								</p>
							</div>
							<div
								className={styles2.statement}
								style={{ marginTop: "20px" }}>
								<h2>Our Business</h2>
								<p style={{ margin: "12px 0" }}>
									The LRC Group (“LRC”) and all of the companies within the LRC
									Group are committed to working to combat slavery and human
									trafficking. We exercise a zero tolerance approach to slavery
									and human trafficking.
								</p>
								<p style={{ margin: "12px 0" }}>
									LRC is a privately held investment and management firm
									operating from affiliated offices throughout the UK and
									Europe, but primarily in London, Dublin, Berlin, Warsaw and
									Larnaca.
								</p>
								<p>The LRC Group consists of the following companies;</p>
								<ul style={{ paddingLeft: "28px" }}>
									{StatemenList3.map((item) => (
										<li>{item}</li>
									))}
								</ul>
								<p style={{ margin: "12px 0" }}>
									LRC’s principals have been active in the European real estate
									markets since 1995 and bring a combined experience of over 125
									years in the international property and finance markets to the
									table.
								</p>
								<p style={{ margin: "12px 0" }}>
									As an opportunity-driven investment group, LRC is not bound by
									fixed investment profiles and return requirements and can
									assess every opportunity based on its individual merits
									without limitations to asset class, volume or jurisdiction. We
									have sourced and acquired real estate assets with a total
									value of over €6bn across Europe. LRC specialises in
									structuring and executing portfolio transactions from
									value-add situations and enhances them through strong in-house
									asset management with a demonstrated track record.
								</p>
								<p style={{ margin: "12px 0" }}>
									This statement is also made in respect of LRC’s subsidiary
									undertaking, Vonder, a global co living lifestyle brand
									offering beautifully designed urban spaces, emphasizing
									experiences and a vibrant local community.
								</p>
							</div>
							<div
								className={styles2.statement}
								style={{ marginTop: "20px" }}>
								<h2>Policy on Slavery for the LRC Group</h2>
								<p style={{ margin: "12px 0" }}>
									LRC considers the risk of slavery and human trafficking within
									its business to be low. However, we recognize that modern
									slavery can occur in any industry, particularly in sectors
									such as hospitality, where outsourced services and complex
									supply chains are common. As such, it is the policy of the LRC
									Group to maintain a zero-tolerance approach to slavery and
									human trafficking within our business and supply chains, with
									a particular focus on hospitality services.
								</p>
								<p style={{ margin: "12px 0" }}>
									To ensure that we are conducting business in an ethical and
									transparent manner, we operate a number of internal policies
									and practices, including:
								</p>
								<p style={{ margin: "12px 0" }}>
									<u>Recruitment.</u> We operate robust recruitment practices,
									including conducting eligibility to work checks for all
									employees and contractors to safeguard against human
									trafficking or individuals being forced to work against their
									will. LRC staff are protected by relevant laws and
									regulations, which are fully reflected in the firm’s policies
									and procedures. Our remuneration packages for all job roles
									meet, or exceed, the minimum national requirements.
									Contractors and consultants who are employed or engaged by
									LRC, carry out highly skilled activities and are therefore
									deemed low risk. LRC places a high value on each of our
									employees and ensures all employment practices adhere to
									national and international labour standards. We offer a work
									environment where there are equal opportunities, fairness,
									inclusiveness, mutual respect and diversity. Our policies and
									procedures are reviewed on a regular basis to enable a
									supportive, safe and accident-free workplace. Our employees
									are at the centre of our health and safety programmes.
								</p>
								<p style={{ margin: "12px 0" }}>
									<u>Whistleblowing.</u> We operate a whistleblowing policy so
									that all employees know they can raise concerns about how
									colleagues are being treated, or practices within our business
									or supply chain, without fear of reprisals.
								</p>
								<p style={{ margin: "12px 0" }}>
									<u>Supply Chain Compliance.</u> We are committed to ensuring
									that there is no modern slavery or human trafficking in our
									supply chains or in any part of our business. This
									anti-slavery and human trafficking statement reflects our
									commitment to acting ethically and with integrity in all our
									business relationships and to implementing and enforcing
									effective systems and controls to ensure slavery and human
									trafficking is not taking place anywhere in our supply chains.
									A risk based approach has been adopted to review supply chains
									that fall within industries that carry a higher risk of modern
									day slavery. We internally review our supply chain to evaluate
									human trafficking risks and slavery risks and, where
									appropriate, we review aspects of the supply chain including
									safety, human trafficking, child labour and other legal
									requirements.
								</p>
								<p style={{ margin: "12px 0" }}>
									LRC has owned and operated hotel properties in the past and
									may do so in the future. These may involve outsourced
									housekeeping and food & beverages suppliers. With regards to
									national or international supply chains in food & beverage, we
									expect these entities to have suitable anti-slavery and human
									trafficking policies and processes. We expect each entity in
									the supplier chain to, at least, adopt ‘one-up’ due diligence
									on the next link in the chain. It is not practical for us (and
									every other participant in the chain) to have a direct
									relationship with all links in the food & beverage chain,
									ultimately to the field or utility generator. Each of LRC and
									Vonder will annually audit its outsourced housekeeping service
									providers to ensure that fair practices are in place along
									with high compliance with employment law.
								</p>
								<p style={{ margin: "12px 0" }}>
									We recognise and understand the complexities associated with
									the existence of modern slavery and its potential impact on
									global supply chain networks and we are committed to working
									with our Suppliers, Customers, Regulatory Authorities and
									other parties and organisations, including NGO’s, to support
									the development of long-term solutions to this issue and its
									abolition.
								</p>
								<p style={{ margin: "12px 0" }}>
									<u>Ongoing Monitoring & Collaboration.</u> We acknowledge the
									complexities of modern slavery and the challenges in global
									supply chain networks. To enhance our efforts, we engage with
									suppliers, customers, and regulatory authorities to develop
									long-term solutions and best practices to combat modern
									slavery. Our compliance team regularly reviews the
									effectiveness of our policies and updates them in line with
									legal and regulatory developments.
								</p>
								<p style={{ margin: "12px 0" }}>
									<u>Training.</u> Where LRC or Vonder provides an accommodation
									service, training will be provided to relevant team members to
									enable them to identify potential signs of slavery, human
									trafficking or child grooming and sexual exploitation.
								</p>
								<p style={{ margin: "12px 0" }}>
									We publish this statement on our website and communicate to
									our suppliers. We provide training to ensure information about
									our commitment to Anti-Slavery and human trafficking is
									communicated throughout our business.{" "}
								</p>
								<p style={{ margin: "12px 0" }}>
									The LRC Group’s management team has endorsed this policy and
									affirms LRC’s commitment to combat Modern Slavery.
								</p>
								<div style={{ marginTop: "20px" }}>
									<p style={{ fontWeight: "bold" }}>Chris Dimitriadis </p>
									<p style={{ fontWeight: "bold" }}>CEO </p>
									<p>Date: 6-Jan-25 </p>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			<Footer />
		</>
	);
};

const StatemenList = [
	`Section 54(1) of the (UK) Modern Slavery Act 2015 and article 4(1) (Schedule 1) of  the Human Rights Act in the UK.`,
	`the Criminal Law (Human Trafficking) Act 2008, as amended by the Criminal Law (Human Trafficking) (Amendment) Act 2013) in Ireland `,
	`Articles 1, 2, 11, 12 and 12a of the Basic Law for the Federal Republic of Germany 
(amendments through 2014), sections 232, 233, 234, 236, 237, 239 & 240 of the 
German Criminal Code, sections 7 & 8 of chapter 1 of Act to Introduce the Codes of 
Crimes against International Law (2002) .`,
	`There is no legislation in place in Poland, which prohibits slavery, although article 31 
of the Constitution guarantees protection of the freedom of the person and 
deprivation of liberty is criminalised under article 189 of the Criminal Code. Slavery 
may also form an element of an offence of trafficking under articles 115(22) and 
189A of the Criminal Code. In addition, various sections of the Polish Labour Code 
and Offences Against the Rights of Persons Pursuing Paid Work Act.`,
	`There is no legislation in place in Malta which prohibits slavery, although article 32 of 
the Constitution recognises the right to liberty and enslavement may form an 
element of crimes against humanity under article 54C of the Criminal Code.  In 
addition, various sections of the Maltese Criminal Code, White Slave Traffic 
(Suppression) Ordinance (Chapter 63 of the Laws of Malta) 1930 and Employment 
and Industrial Relations Act 2002 contain relevant guidance.`,
	`In Cyprus Law number 60 of 2014 on the Prevention, Fighting against Trafficking in 
and Exploitation of Human Beings and Protection of Victims.`,
];

const StatemenList2 = [
	`the trafficking of adults into conditions of criminal exploitation`,
	`the trafficking of adults into conditions of labour exploitation `,
	`the trafficking of minors into conditions of sexual, criminal or labour exploitation `,
	`the sexual exploitation of adults`,
	`other forms of exploitation `,
];

const StatemenList3 = [
	`LRC UK Ltd`,
	`LRC Management UK Ltd`,
	`LRC Management Ireland Ltd `,
	`LRC Management Europe Ltd `,
	`LRC Real Estate Ltd `,
	`LRC Group GmbH`,
	`LRC Poland Sp. Z o.o.`,
	`Vonder UK Ltd `,
	`Vonder UK Accommodation Ltd`,
	`Vonder GmbH `,
	`Vonder Poland Sp. Z o.o.`,
	`Vonder DBI`,
];

export default ModernSlaveryStatement;
